import React from "react";
import { Wrench, CreditCard, Wallet, AlertTriangle, ChevronRight } from "lucide-react";
import { useT } from "@/lib/i18n";

const CONF = {
  maintenance: { icon: Wrench },
  payment: { icon: CreditCard },
  cash: { icon: Wallet },
};
const SEV = {
  danger: "bg-rose-50 text-rose-600 border-rose-100",
  warning: "bg-amber-50 text-amber-600 border-amber-100",
  info: "bg-blue-50 text-blue-600 border-blue-100",
};

export default function AlertsPanel({ alerts, onAction }) {
  const { t } = useT();
  return (
    <div className="rounded-xl border border-slate-200/80 bg-white p-5 shadow-[0_1px_3px_0_rgba(15,23,42,0.04)]" data-testid="alerts-panel">
      <div className="mb-4 flex items-center gap-2">
        <AlertTriangle className="h-4.5 w-4.5 text-amber-500" style={{ width: 18, height: 18 }} />
        <h3 className="text-lg font-semibold text-slate-900">{t("dash.alerts")}</h3>
        {alerts.length > 0 && <span className="rounded-full bg-slate-100 px-2 py-0.5 text-xs font-semibold text-slate-600">{alerts.length}</span>}
      </div>
      {alerts.length === 0 ? (
        <p className="py-8 text-center text-sm text-slate-400">Aucune alerte — tout est en ordre</p>
      ) : (
        <div className="space-y-2.5">
          {alerts.map((a, i) => {
            const Icon = (CONF[a.type] || CONF.cash).icon;
            return (
              <div key={i} className="flex items-center gap-3 rounded-lg border border-slate-100 p-3 transition-colors hover:bg-slate-50" data-testid={`alert-${a.type}-${i}`}>
                <div className={`flex h-9 w-9 shrink-0 items-center justify-center rounded-lg border ${SEV[a.severity] || SEV.info}`}>
                  <Icon className="h-4 w-4" />
                </div>
                <div className="min-w-0 flex-1">
                  <p className="truncate text-sm font-semibold text-slate-900">{a.title}</p>
                  <p className="truncate text-xs text-slate-500">{a.description}</p>
                </div>
                <button onClick={() => onAction?.(a)} className="flex shrink-0 items-center gap-0.5 text-xs font-medium text-primary hover:underline">
                  {a.action} <ChevronRight className="h-3.5 w-3.5" />
                </button>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
}
